import { useState } from 'react'
import type { Product } from '../lib/db'
import { money, QTY_UNIT } from '../lib/money'
import { Sheet } from './Sheet'
import { NumPad } from './NumPad'

interface Props {
  product: Product
  onClose: () => void
  onConfirm: (qtyMilli: number) => void | Promise<void>
}

/**
 * Bán theo cân. Sạp thịt cân xong nhìn thấy con số nào trước thì gõ con số đó:
 * người thì gõ số ký, người thì gõ thẳng số tiền khách phải trả. Cho cả hai đường,
 * và luôn hiện con số còn lại để họ đối chiếu.
 */
export function WeightSheet({ product, onClose, onConfirm }: Props) {
  const [mode, setMode] = useState<'weight' | 'amount'>('weight')
  const [raw, setRaw] = useState(0)

  // Chế độ cân: gõ 125 nghĩa là 1,25 kg — bàn phím số không có dấu phẩy.
  const qtyMilli = mode === 'weight' ? raw * 10 : Math.round((raw * QTY_UNIT) / product.price)
  const amount = mode === 'weight' ? Math.round((product.price * qtyMilli) / QTY_UNIT) : raw

  const kg = (qtyMilli / QTY_UNIT).toFixed(2).replace('.', ',')

  return (
    <Sheet title={product.name} onClose={onClose}>
      <p className="sheet-note">
        {money(product.price)}đ / {product.unit}
      </p>

      <div className="seg">
        <button type="button" aria-pressed={mode === 'weight'} onClick={() => { setMode('weight'); setRaw(0) }}>
          Gõ số ký
        </button>
        <button type="button" aria-pressed={mode === 'amount'} onClick={() => { setMode('amount'); setRaw(0) }}>
          Gõ số tiền
        </button>
      </div>

      <div className="weigh-readout">
        <div className={mode === 'weight' ? 'weigh-main' : 'weigh-sub'}>
          <span className="num">{kg}</span> kg
        </div>
        <div className={mode === 'amount' ? 'weigh-main' : 'weigh-sub'}>
          <span className="num">{money(amount)}</span> đ
        </div>
      </div>

      <NumPad
        value={raw}
        onChange={setRaw}
        extraKey={mode === 'amount' ? '000' : undefined}
      />

      <div className="sheet-actions">
        <button
          type="button"
          className="btn btn-brand grow"
          disabled={qtyMilli <= 0}
          onClick={() => void onConfirm(qtyMilli)}
        >
          Thêm · {money(amount)}
        </button>
      </div>
    </Sheet>
  )
}
